export default __webpack_public_path__ + "4f762f7708d01aa0fc7191fc2ab09bfc.svg";